import React, { Component } from "react";

import { withUnits } from "../../../../shared/containers/containerUnits";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { getCarsTypeName } from "../../../sections/cars/static.carsTypes";

import styles from "./winterUnitsBar.module.scss";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import { withWinter } from "../../../../shared/containers/containerWinter";

class WinterUnitListItem extends Component {
  constructor(props) {
    super(props);
  }

  onClickHandler() {
    const {
      data,
      isCheck,
      onDeleteWinterUnit,
      onAddWinterUnit,
      selectedWinterGroup,
      onAddWinterUnitGroup,
      onDeleteWinterUnitGroup,
    } = this.props;
    const unit = { ...data.unit, id: data.id };

    if (selectedWinterGroup === null) {
      if (isCheck) {
        onDeleteWinterUnit(unit);
      } else {
        onAddWinterUnit(unit);
      }
    } else {
      if (isCheck) {
        onDeleteWinterUnitGroup(unit, selectedWinterGroup);
      } else {
        onAddWinterUnitGroup(unit, selectedWinterGroup);
      }
    }
  }

  render() {
    const { data, isCheck } = this.props;

    const getStatusStyles = () => {
      switch (getCarsTypeName(data.status.id)) {
        case "noData":
          return styles.container_carNumber_noData;
        case "inMove":
          return styles.container_carNumber_inMove;
        case "parking":
          return styles.container_carNumber_parking;
        default:
          return null;
      }
    };

    return (
      <div className={styles.carsListItemWrapper}>
        <div className={styles.container_carsListItemWrapper}>
          <div className={styles.carsListItem}>
            <TooltipWrapper title={data.status.title} position="right">
              <div className={getStatusStyles()}>
                <span className={styles.title}>{data.number}</span>
              </div>
            </TooltipWrapper>

            <div className={styles.carsListItemInner}>
              <div className={styles.container_carContent}>
                <div className={styles.container_name}>
                  <div>{data.unit.title}</div>

                  <div>{data.unit.registerNumber}</div>
                </div>
              </div>

              <div
                className={styles.container_params}
                onClick={(e) => {
                  e.stopPropagation();
                  this.onClickHandler();
                }}
              >
                <TooltipWrapper
                  title={
                    isCheck
                      ? `Убрать ${data.unit.title} ${data.unit.registerNumber}`
                      : `Добавить ${data.unit.title} ${data.unit.registerNumber}` 
                  }
                  position="top"
                >
                  {isCheck ? (
                    <div className={styles.container_itemChecked}>
                      <CheckCircleIcon fontSize="small" />
                    </div>
                  ) : (
                    <div className={styles.container_itemUnchecked}>
                      <CheckCircleOutlineIcon fontSize="small" />
                    </div>
                  )}
                </TooltipWrapper>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withWinter(withUnits(React.memo(WinterUnitListItem)));
